import axios from "../../utils/axiosConfig";
import {
  ShiftAssignDTO,
  getShiftDutiesByIdDTO,
  putShiftDutiesDTO,
  deleteShiftDutyDTO
} from "../../dtos/shift";
import decryptResponse from "../../utils/decrypt_new";

// 1) Add staff duty (POST Call)
const addStaffDuty = async (shift: ShiftAssignDTO) => {
  try {
    const { data } = await axios.post("/api/pharmacy_staff_duty/add_pharmacy_staff_duty", shift);

    if (data?.data?.encryptedData && data?.data?.iv) {
      return decryptResponse(data?.data?.encryptedData, data?.data.iv);
    } else {
     return data;
    }
  } catch (error) {
    console.error("Error adding staff duty:", error);
    throw new Error("Failed to add staff duty");
  }
};

 
// 2) Get pharmacy staff duties (GET Call)
const getStaffDuties = async (id: number) => {
try{
  const { data } = await axios.get("/api/pharmacy_staff_duty/get_pharmacy_staff_duty", {
    params: { pharmacy_id: id },  // Correctly passing the parameter in 'params'
  });
  if (data?.data?.encryptedData && data?.data?.iv) {
    return decryptResponse(data?.data?.encryptedData, data?.data.iv)
  } else {
    return data?.data;
  }

} catch (error) {
  console.error("Error adding staff duty:", error);
  throw new Error("Failed to add staff duty");
}
};


// 3. Get Staff duty by id (GET Call)
const getStaffDutiesByID = async (shift: getShiftDutiesByIdDTO) => {
  try {
   
    const { data } = await axios.get("/api/pharmacy_staff_activity/get_staff_activity_by_id", {
      params: shift, 
    });
    if (data?.data?.encryptedData && data?.data?.iv) {
      return decryptResponse(data?.data?.encryptedData, data?.data?.iv);
    }else {
      return data?.data;
    }
  } catch (error) {
    throw new Error("Failed to fetch staff duty by ID");
  }
};

// 4.Update staff duty (PUT Call)
const putStaffDutiesUpdate = async (shift: putShiftDutiesDTO) => {
  try {
    const { data } = await axios.put("/api/pharmacy_staff_duty/update_pharmacy_staff_duty", shift);
    if (data?.data?.encryptedData && data?.data?.iv) {
        return decryptResponse(data?.data?.encryptedData, data?.data.iv);
    } else {
     return data;
    }
  } catch (error) {
    console.error("Error updating staff duty:", error);
    throw new Error("Failed to update staff duty");
  }
};

// 5. Delete staff duty (DELETE Call)
const deleteStaffDuty = async (shift: deleteShiftDutyDTO) => {
  try{
  const { data } = await axios.delete(`/api/pharmacy_staff_duty/delete_pharmacy_staff_duty`, { data: shift });
  if (data?.data?.encryptedData && data?.data?.iv) {
    return decryptResponse(data?.data?.encryptedData, data?.data.iv);
  } else {
   return data;
  }
} catch (error) {
  console.error("Error adding staff duty:", error);
  throw new Error("Failed to add staff duty");
}
};

// 6. Get All Staff Activity
const getAllStaffDuties = async (id: number) => {
  try {
   
    const { data } = await axios.get("/api/pharmacy_staff_activity/get_staff_activity", {
      params: { pharmacy_id: id }, 
    });
    if (data?.data?.encryptedData && data?.data?.iv) {
      // Decrypt and return the response data
      return decryptResponse(data?.data?.encryptedData, data?.data?.iv);
    }else {
      return data?.data;
    }
  } catch (error) {
    throw new Error("Failed to fetch staff duty by ID");
  }
};

const shiftService = {
  addStaffDuty,
  getStaffDuties,
  getStaffDutiesByID,
  putStaffDutiesUpdate,
  deleteStaffDuty,
  getAllStaffDuties
};

export default shiftService;
